import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Grid,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import configServ from "../../services/config";
import { useEffect, useState } from "react";
import { Skeleton } from "@mui/material";
import Swal from "sweetalert2";
import { Try } from "@mui/icons-material";
import { useSelector } from "react-redux";
const EnquiryDialog = ({
  open,
  onClose,
  enquiryData,
  onApprove,
  onsuccess,
}) => {
  const [paymentDetails, setPaymentDetails] = useState([]);
  const [courseDetails, setCourseDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetchedData, setFetchedData] = useState([]);
  const { company_id } = useSelector((state) => state.GlobalVariables);

  const isActionDisabled =
    fetchedData?.length === 0 ||
    paymentDetails?.status === "approved" ||
    enquiryData?.status === "payment_failed" ||
    enquiryData?.status === "completed";

  const fetchpaymentList = async () => {
    if (!enquiryData) return;

    try {
      setLoading(true);
      const payload = {
        enquiry_id: enquiryData.id,
        course_id: enquiryData.course_id,
      };
      const res = await configServ.getPaymentAndCourseDetails(payload);
      if (res.status) {
        setFetchedData(res);
        setPaymentDetails(res.payment_details);
        setCourseDetails(res.course_details);
      } else {
        setFetchedData([]);
        setPaymentDetails([]);
        setCourseDetails([]);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open && enquiryData) {
      fetchpaymentList();
    }
  }, [open, enquiryData]);

  const handleReject = async () => {
    onClose();
    const { value: remarks } = await Swal.fire({
      title: "Reject Payment?",
      input: "textarea",
      inputLabel: "Reason for rejection",
      inputPlaceholder: "Type your remarks here...",
      inputAttributes: {
        "aria-label": "Type your remarks here",
      },
      showCancelButton: true,
      confirmButtonText: "Reject",
      cancelButtonText: "Cancel",
      inputValidator: (value) => {
        if (!value.trim()) {
          return "Remarks are required to reject the payment.";
        }
      },
    });

    if (remarks) {
      try {
        const payload = {
          payment_id: paymentDetails.id,
          remarks: remarks.trim(),
        };

        const res = await configServ.rejectPayment(payload);

        if (res.status) {
          Swal.fire("Rejected!", "The payment has been rejected.", "success");
          onsuccess(); // Refresh or close
        } else {
          Swal.fire("Failed", "Rejection failed. Try again later.", "error");
        }
      } catch (error) {
        console.error("Error rejecting enquiry:", error);
        Swal.fire("Error", "Something went wrong on the server.", "error");
      }
    }
  };

  const handleApproved = async () => {
    try {
      const payload = {
        email: enquiryData.email,
        name: enquiryData.name,
        phone: enquiryData.phone,
        course_id: enquiryData.course_id,
        enquiry_id: enquiryData.id,
        company_id: company_id,
      };
      const res = await configServ.approvedSubscription(payload);
      if (res.status) {
        Swal.fire(
          "Approved!",
          "Subscription approved successfully.",
          "success"
        );
        onsuccess(); // Refresh or close
        onClose();
      } else {
        Swal.fire("Failed", "Subscription failed. Try again later.", "error");
      }
    } catch (error) {
      console.error("Error rejecting enquiry:", error);
      Swal.fire("Error", "Something went wrong on the server.", "error");
    }
  };

  if (!enquiryData) return null;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ m: 0, p: 2 }}>
        Payment Details
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2">Transaction ID</Typography>
            {loading ? (
              <Skeleton width={120} />
            ) : (
              <Typography>{paymentDetails.transaction_id || "N/A"}</Typography>
            )}
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2">Amount</Typography>
            {loading ? (
              <Skeleton width={120} />
            ) : (
              <Typography>₹{paymentDetails.amount || 0}</Typography>
            )}
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2">Status</Typography>
            {loading ? (
              <Skeleton width={120} />
            ) : (
              <Typography>{paymentDetails.status || "N/A"}</Typography>
            )}
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2">Tracking ID</Typography>
            {loading ? (
              <Skeleton width={120} />
            ) : (
              <Typography>{paymentDetails.tracking_id || "N/A"}</Typography>
            )}
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2">Remark's</Typography>
            {loading ? (
              <Skeleton width={120} />
            ) : (
              <Typography>{paymentDetails.remarks || "N/A"}</Typography>
            )}
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2">Transaction Image</Typography>
            {loading ? (
              <Skeleton variant="rectangular" width="100%" height={200} />
            ) : (
              paymentDetails.transaction_image && (
                <img
                  src={paymentDetails.transaction_image}
                  alt="Transaction"
                  style={{ maxWidth: "100%", borderRadius: 8 }}
                />
              )
            )}
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h6" mt={2}>
              Course Details
            </Typography>

            <Typography>
              <strong>Title:</strong>{" "}
              {loading ? (
                <Skeleton width={120} />
              ) : (
                courseDetails?.title || "N/A"
              )}
            </Typography>

            <Typography>
              <strong>Price:</strong>{" "}
              {loading ? (
                <Skeleton width={120} />
              ) : (
                `₹${courseDetails?.price || 0}`
              )}
            </Typography>

            <Typography>
              <strong>Discount Price:</strong>{" "}
              {loading ? (
                <Skeleton width={120} />
              ) : (
                `₹${courseDetails?.discount_price || "N/A"}`
              )}
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={handleApproved}
          variant="contained"
          color="success"
          disabled={isActionDisabled}
        >
          Approve
        </Button>
        <Button
          onClick={handleReject}
          variant="contained"
          color="error"
          disabled={isActionDisabled}
        >
          Reject
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EnquiryDialog;
